/* Omega instant add: Details + Add on product cards (Amino Club style).
   Single-size products add instantly. Multi-size products open a "Choose a size" picker.
   Button, cart count and floating cart pill update instantly; Shopify syncs in the background. */
(function () {
  if (window.__omegaQuickAdd) return;
  window.__omegaQuickAdd = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var state = { count: 0, total: 0 };
  var pill = null, picker = null, syncTimer = null, inflight = 0;
  var PLUS = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
  var TICK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  function money(c) { return '$' + (Number(c || 0) / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- Floating cart pill ---------- */
  function buildPill() {
    if (pill || /^\/(cart|checkout|pages\/secure-checkout)/.test(location.pathname)) return;
    pill = document.createElement('button');
    pill.type = 'button';
    pill.className = 'oqa-pill';
    pill.setAttribute('aria-label', 'View cart');
    pill.innerHTML =
      '<span class="oqa-pill__ic"><svg viewBox="0 0 24 24"><path d="M5 7h14l-1.2 12.2a2 2 0 0 1-2 1.8H8.2a2 2 0 0 1-2-1.8L5 7Z"/><path d="M9 10V6a3 3 0 0 1 6 0v4"/></svg><span class="oqa-pill__n">0</span></span>' +
      '<span class="oqa-pill__tot">$0.00</span>' +
      '<span class="oqa-pill__go">View cart<svg viewBox="0 0 24 24"><path d="M5 12h14M13 5l7 7-7 7"/></svg></span>';
    pill.addEventListener('click', openCart);
    document.body.appendChild(pill);
    renderPill();
  }
  function renderPill(bump) {
    if (!pill) return;
    pill.querySelector('.oqa-pill__n').textContent = state.count > 99 ? '99+' : state.count;
    pill.querySelector('.oqa-pill__tot').textContent = money(state.total);
    pill.classList.toggle('is-on', state.count > 0);
    if (bump) { pill.classList.remove('is-bump'); void pill.offsetWidth; pill.classList.add('is-bump'); }
  }
  function openCart() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.classList.remove('is-empty'); drawer.open(pill); }
    else window.location.href = root + 'cart';
  }

  /* ---------- Header cart bubble ---------- */
  function setBubble(n) {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    var bubble = icon.querySelector('.cart-count-bubble');
    if (n <= 0) { if (bubble) bubble.remove(); return; }
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
      icon.appendChild(bubble);
    }
    var a = bubble.querySelector('[aria-hidden]');
    if (a) a.textContent = n < 100 ? n : '';
  }

  /* ---------- Sync with the real cart ---------- */
  function sync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      if (inflight > 0) return sync();
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { state.count = c.item_count; state.total = c.total_price; renderPill(); setBubble(c.item_count); })
        .catch(function () {});
    }, 250);
  }
  function replaceSections(sections) {
    if (!sections) return;
    var p = new DOMParser();
    if (sections['cart-drawer']) {
      var d = p.parseFromString(sections['cart-drawer'], 'text/html');
      var src = d.querySelector('#CartDrawer'), dst = document.querySelector('#CartDrawer');
      if (src && dst) dst.innerHTML = src.innerHTML;
      var el = document.querySelector('cart-drawer');
      if (el) el.classList.remove('is-empty');
    }
    if (sections['cart-icon-bubble']) {
      var b = p.parseFromString(sections['cart-icon-bubble'], 'text/html');
      var inner = b.querySelector('.shopify-section'), icon = document.getElementById('cart-icon-bubble');
      if (inner && icon) icon.innerHTML = inner.innerHTML;
    }
  }

  /* ---------- Add to cart (instant feedback, real add in background) ---------- */
  function add(id, price, ui) {
    state.count += 1; state.total += price;
    buildPill(); renderPill(true); setBubble(state.count);
    ui.ok();
    var body = { items: [{ id: id, quantity: 1 }] };
    if (document.querySelector('cart-drawer')) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = window.location.pathname; }
    inflight++;
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        inflight--;
        if (!res.ok) ui.fail(res.j && res.j.status === 422 ? 'Max in cart' : 'Try again');
        else {
          replaceSections(res.j.sections);
          try { if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'omega-quick-add', productVariantId: id }); } catch (x) {}
        }
        sync();
      })
      .catch(function () { inflight--; sync(); });
  }
  function cardUI(btn) {
    var lbl = btn.querySelector('.oqa__lbl'), original = lbl.innerHTML;
    function reset(ms) { clearTimeout(btn.__t); btn.__t = setTimeout(function () { btn.classList.remove('is-added', 'is-error'); lbl.innerHTML = original; }, ms); }
    return {
      ok: function () { btn.classList.remove('is-error'); btn.classList.add('is-added'); lbl.innerHTML = TICK + 'Added'; reset(1400); },
      fail: function (msg) { btn.classList.remove('is-added'); btn.classList.add('is-error'); lbl.textContent = msg; reset(1800); }
    };
  }

  /* ---------- "Choose a size" picker ---------- */
  function buildPicker() {
    if (picker) return picker;
    picker = document.createElement('div');
    picker.className = 'oqa-pick';
    picker.setAttribute('hidden', '');
    picker.innerHTML =
      '<div class="oqa-pick__bg" data-oqa-close></div>' +
      '<div class="oqa-pick__box" role="dialog" aria-modal="true" aria-labelledby="OqaPickTitle">' +
        '<button type="button" class="oqa-pick__x" data-oqa-close aria-label="Close"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '<p class="oqa-pick__t" id="OqaPickTitle"></p>' +
        '<p class="oqa-pick__s"></p>' +
        '<div class="oqa-pick__list"></div>' +
      '</div>';
    document.body.appendChild(picker);
    picker.addEventListener('click', function (e) {
      if (e.target.closest('[data-oqa-close]')) { closePicker(); return; }
      var row = e.target.closest('[data-oqa-pick]');
      if (!row || row.disabled) return;
      var plus = row.querySelector('.oqa-pick__plus');
      add(Number(row.getAttribute('data-id')), Number(row.getAttribute('data-price')), {
        ok: function () { row.classList.add('is-added'); plus.innerHTML = TICK; setTimeout(closePicker, 450); },
        fail: function (msg) { row.classList.remove('is-added'); row.classList.add('is-error'); plus.innerHTML = PLUS; row.querySelector('.oqa-pick__p').textContent = msg; }
      });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !picker.hasAttribute('hidden')) closePicker(); });
    return picker;
  }
  function openPicker(data) {
    buildPicker();
    picker.querySelector('.oqa-pick__t').textContent = data.title;
    picker.querySelector('.oqa-pick__s').textContent = 'Choose a ' + String(data.option || 'size').toLowerCase();
    picker.querySelector('.oqa-pick__list').innerHTML = data.variants.map(function (v) {
      var price = v.available
        ? (v.compare > v.price ? '<s>' + money(v.compare) + '</s>' : '') + '<b>' + money(v.price) + '</b>'
        : '<em>Sold out</em>';
      return '<button type="button" class="oqa-pick__row" data-oqa-pick data-id="' + v.id + '" data-price="' + v.price + '"' + (v.available ? '' : ' disabled') + '>' +
        '<span class="oqa-pick__n">' + esc(v.title) + '</span>' +
        '<span class="oqa-pick__p">' + price + '</span>' +
        '<span class="oqa-pick__plus">' + PLUS + '</span></button>';
    }).join('');
    picker.removeAttribute('hidden');
    document.documentElement.classList.add('oqa-lock');
    requestAnimationFrame(function () { picker.classList.add('is-open'); });
    var first = picker.querySelector('[data-oqa-pick]:not([disabled])');
    if (first) first.focus({ preventScroll: true });
  }
  function closePicker() {
    if (!picker) return;
    picker.classList.remove('is-open');
    document.documentElement.classList.remove('oqa-lock');
    setTimeout(function () { picker.setAttribute('hidden', ''); }, 200);
  }

  /* ---------- Card clicks ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-oqa-add]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    if (btn.disabled) return;
    var box = btn.closest('[data-oqa]');
    if (box.hasAttribute('data-multi')) {
      var json = box.querySelector('[data-oqa-json]');
      try { openPicker(JSON.parse(json.textContent)); } catch (x) {}
      return;
    }
    add(Number(box.getAttribute('data-variant')), Number(box.getAttribute('data-price')) || 0, cardUI(btn));
  }, true);

  /* Keep the pill in step when the cart changes elsewhere (product page, cart drawer) */
  var _fetch = window.fetch;
  window.fetch = function (input) {
    var p = _fetch.apply(this, arguments);
    try {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update|clear)/.test(u)) p.then(function () { if (!inflight) sync(); }, function () {});
    } catch (x) {}
    return p;
  };

  function init() { buildPill(); sync(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
